import React, { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Banner } from '@/components/ui/banner';
import { User, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ProfileCompletionChecker = () => {
  const { member, isLoading } = useAuth();
  const navigate = useNavigate();
  const [showBanner, setShowBanner] = useState(false);
  const [hasChecked, setHasChecked] = useState(false);

  useEffect(() => {
    if (!isLoading && member && !hasChecked) {
      setHasChecked(true);
      
      const profileFields = [
        member.firstname, member.lastname, member.email, member.company, 
        member.role, member.city, member.country, member.bio, 
        member.skills, member.languages, member.industry
      ];
      const completedFields = profileFields.filter(field => 
        field && (Array.isArray(field) ? field.length > 0 : field.toString().trim() !== '')
      ).length;
      const completeness = (completedFields / profileFields.length) * 100;
      
      if (completeness < 60) {
        setShowBanner(true);
      }
    }
  }, [member, isLoading, hasChecked]);

  const handleComplete = () => {
    navigate('/profile?edit=true');
  };

  const handleClose = () => {
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  const getMissingFields = () => {
    const missing = [];
    if (!member?.industry) missing.push('secteur d\'activité');
    if (!member?.skills?.length && !member?.needs?.length) missing.push('compétences ou besoins');
    return missing;
  };

  return (
    <Banner 
      variant="primary" 
      position="top"
      onClose={handleClose}
      className="animate-in slide-in-from-top-2 duration-500"
    >
      <div className="flex items-center gap-3">
        <User className="h-5 w-5 shrink-0" />
        <div className="flex-1">
          <span className="font-medium">Complétez votre profil pour de meilleures connexions</span>
          <div className="text-sm opacity-90 mt-1">
            Manquant: {getMissingFields().join(', ')}
          </div>
        </div>
        <button
          onClick={handleComplete}
          className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-md text-sm font-medium transition-colors flex items-center gap-2"
        >
          <Settings className="h-4 w-4" />
          Compléter
        </button>
      </div>
    </Banner>
  );
};

export default ProfileCompletionChecker;